import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import { statusOptions } from "../_common/qmsConstants";
import { getLocalISOString } from "../../../_utils/generalUtils";

export default function CmtModal_EditActionItem(props) {
  const { modalState, toggleModal } = props;

  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);

  const [isHighPriority, setHighPriority] = useState(false);
  const [selectedStatus, setStatus] = useState(
    statusOptions.find((so) => so.value === 1)
  );
  const [title, setTitle] = useState("");

  const handleClick_add = async (e) => {
    e.preventDefault();
    const newIssueActionItemData = {
      issueActionItemId: 0,
      issueId: modalState.data.issue.issueId,
      createdByQmsUserId: modalState.data.qmsUserId,
      createdOn: getLocalISOString(new Date()),
      title,
      priorityDisplayName: "",
      priorityValue: isHighPriority ? 3 : 1,
      statusValue: selectedStatus.value,
      statusDisplayName: "",
      startedOn: selectedStatus.value === 2 ? getLocalISOString(new Date()) : null,
      startedOnIssueStageId: modalState.data.selectedStageId,
      completedOn: null,
      completedOnIssueStageId: null,
      isDeleted: false,
      deletedOn: null,
      reasonForDeletion: "",
    };
    console.log("newAI=", newIssueActionItemData);
    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId: modalState.data.issue.issueId,
      fieldsToUpdate: {
        actionItems: [
          ...(modalState.data.issue.actionItems || []),
          newIssueActionItemData,
        ],
      },
    });
    dispatch(cmtIssueActions.update(modalState.data.issue.issueId));

    // Reload issue with updated issueStageSnippets
    dispatch(cmtIssueActions.get(modalState.data.issue.issueId));

    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"lg"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Add New Stage
      </ModalHeader>
      <ModalBody className="px-3">
        <div className="row mb-2">
          <div className="form-group col-md-3 mb-0 pr-2">
            <Select
              id="status"
              name="status"
              className="pl-0"
              value={selectedStatus}
              options={statusOptions}
              onChange={(selected) => setStatus(selected)}
            />
          </div>
          <div className="form-group col-md-3 mb-0 my-auto">
            <div className="custom-control-inline custom-control custom-checkbox">
              <input
                type="checkbox"
                name="isHighPriority"
                id="isHighPriority"
                className="custom-control-input my-auto"
                value={isHighPriority}
                checked={isHighPriority}
                onChange={(e) => setHighPriority(e.target.checked)}
              />
              <label htmlFor="isHighPriority" className="custom-control-label my-auto">
                High priority
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-12 mb-1">
            <label htmlFor="title" className="mb-0 font-weight-bold">
              Title:*
            </label>
            <input
              id="title"
              name="title"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>
        {/* <div className="row">
            <div className="form-group col-12 mb-1">
              <label htmlFor="description" className="mb-0 font-weight-bold">
                Description:*
              </label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-5 mb-1 pr-1">
              <label htmlFor="startedOn" className="mb-0 font-weight-bold">
                Start Date:*
              </label>
              <DatePicker
                customInput={<CustomDatePickerInput />}
                name="reportStartDate"
                id="reportStartDate"
                selected={startedOn}
                dateFormat="MM/dd/yyyy (E)"
                onChange={(selected) => setStartedOn(selected)}
              />
            </div>
            <div className="form-group col-sm-4 mb-1 pl-1">
              <label htmlFor="duration" className="mb-0">
                Expected Duration:
              </label>
              <div className="input-group mb-0">
                <input
                  type="number"
                  id="duration"
                  name="duration"
                  className="form-control"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                />
                <div className="input-group-append">
                  <span className="input-group-text">Days</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-12 mb-1">
              <label htmlFor="status" className="mb-0 font-weight-bold">
                Stage Owner:*
              </label>
              <Select
                id="status"
                name="status"
                className="pl-0"
                value={selectedOwnerTeam}
                options={qmsTeamOptions}
                onChange={(selected) => setOwnerTeam(selected)}
                isClearable
              />
            </div>
          </div>
          <div className="alert alert-warning d-flex flex-row px-2 py-1 mt-2">
            <div style={{ width: "fit-content" }}>
              <FontAwesomeIcon icon="exclamation-triangle" className="fa-fw mr-2" />
            </div>
            <div className="pl-2">
              Once added, this stage will be marked as current, and all previous stages
              will be marked complete.
            </div>
          </div> */}
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="open"
            id="open"
            className="btn btn-primary mr-2"
            onClick={handleClick_add}
          >
            {fetching && (
              <span className="mr-2 mt-1">
                <FontAwesomeIcon
                  icon="spinner"
                  className="loading-spinner"
                  style={{ color: "white" }}
                />
              </span>
            )}
            <b>Add</b>
          </button>
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
